export default "__VITE_ASSET__QoHRbysq__"